import Vue from "vue";

// Filters
import { capitalize, date, shortDate, mediumDate, longDate, money, uppercase, lowercase } from "@/filters";
Vue.filter("capitalize", capitalize);
Vue.filter("date", date);
Vue.filter("shortDate", shortDate);
Vue.filter("mediumDate", mediumDate);
Vue.filter("longDate", longDate);
Vue.filter("money", money);
Vue.filter("uppercase", uppercase);
Vue.filter("lowercase", lowercase);
